import { Loader } from "@googlemaps/js-api-loader";

export async function loadLibraries(apiKey: string): Promise<{
  mapsLibrary: google.maps.MapsLibrary;
  markerLibrary: google.maps.MarkerLibrary;
  geocodingLibrary: google.maps.GeocodingLibrary;
}> {
  const loader = new Loader({ apiKey });

  try {
    const [mapsLibrary, markerLibrary, geocodingLibrary] = await Promise.all([
      loader.importLibrary("maps"),
      loader.importLibrary("marker"),
      loader.importLibrary("geocoding"),
    ]);

    return {
      mapsLibrary,
      markerLibrary,
      geocodingLibrary,
    };
  } catch (e) {
    throw new Error(`Libraries not loaded: ${e}`);
  }
}
